/**
 * VistaGare accessibility widget — preferences via html.vg-a11y-* + localStorage.
 * Shortcut: Alt+Shift+A (Win/Linux) / Option+Shift+A (macOS).
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'vg-a11y-prefs';
    var modalEl = null;
    var triggerEl = null;
    var prevFocus = null;

    var DEFAULT_PREFS = {
        contrast: false,
        invertColors: false,
        textSize: 'normal',
        spacing: false,
        focusStrong: false,
        underlineLinks: false,
        reduceMotion: false,
        readableFont: false
    };

    var OPTIONS = [
        { key: 'contrast', label: 'Contrasto elevato', hint: 'Migliora la leggibilità di testi e controlli' },
        { key: 'invertColors', label: 'Inverti colori', hint: 'Scambia sfondo e testo su tutta la pagina' },
        { key: 'textSize', label: 'Testo più grande', hint: 'Cicla: normale → grande → extra grande', cycle: ['normal', 'lg', 'xl'] },
        { key: 'spacing', label: 'Spaziatura testo', hint: 'Interlinea e spaziatura tra lettere aumentate' },
        { key: 'focusStrong', label: 'Evidenzia focus', hint: 'Contorno più visibile su tastiera' },
        { key: 'underlineLinks', label: 'Sottolinea link', hint: 'I link non dipendono solo dal colore' },
        { key: 'reduceMotion', label: 'Riduci animazioni', hint: 'Disattiva transizioni e animazioni' },
        { key: 'readableFont', label: 'Font leggibile', hint: 'Sans-serif di sistema' }
    ];

    function loadPrefs() {
        try {
            var raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return Object.assign({}, DEFAULT_PREFS);
            var parsed = JSON.parse(raw);
            return Object.assign({}, DEFAULT_PREFS, parsed);
        } catch (e) {
            return Object.assign({}, DEFAULT_PREFS);
        }
    }

    function savePrefs(prefs) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
        } catch (e) {}
    }

    function applyPrefs(prefs) {
        prefs = prefs || loadPrefs();
        var html = document.documentElement;

        html.classList.remove(
            'vg-a11y-contrast',
            'vg-a11y-invert-colors',
            'vg-a11y-text-lg',
            'vg-a11y-text-xl',
            'vg-a11y-spacing',
            'vg-a11y-focus-strong',
            'vg-a11y-underline-links',
            'vg-a11y-reduce-motion',
            'vg-a11y-readable-font'
        );

        if (prefs.contrast) html.classList.add('vg-a11y-contrast');
        if (prefs.invertColors) html.classList.add('vg-a11y-invert-colors');
        if (prefs.textSize === 'lg') html.classList.add('vg-a11y-text-lg');
        if (prefs.textSize === 'xl') html.classList.add('vg-a11y-text-xl');
        if (prefs.spacing) html.classList.add('vg-a11y-spacing');
        if (prefs.focusStrong) html.classList.add('vg-a11y-focus-strong');
        if (prefs.underlineLinks) html.classList.add('vg-a11y-underline-links');
        if (prefs.reduceMotion) html.classList.add('vg-a11y-reduce-motion');
        if (prefs.readableFont) html.classList.add('vg-a11y-readable-font');

        if (modalEl) {
            syncToggleButtons(prefs);
            announcePrefChange(prefs);
        }

        /* Force layout so font-size / filter updates paint before next frame */
        void html.offsetHeight;
    }

    function announcePrefChange(prefs) {
        var live = modalEl && modalEl.querySelector('[data-a11y-live]');
        if (!live) return;
        var parts = [];
        if (prefs.contrast) parts.push('contrasto elevato');
        if (prefs.invertColors) parts.push('colori invertiti');
        if (prefs.textSize === 'lg') parts.push('testo grande');
        if (prefs.textSize === 'xl') parts.push('testo extra grande');
        if (prefs.spacing) parts.push('spaziatura testo');
        if (prefs.focusStrong) parts.push('focus evidenziato');
        if (prefs.underlineLinks) parts.push('link sottolineati');
        if (prefs.reduceMotion) parts.push('animazioni ridotte');
        if (prefs.readableFont) parts.push('font leggibile');
        live.textContent = parts.length
            ? 'Preferenze attive: ' + parts.join(', ')
            : 'Preferenze predefinite';
    }

    function optionPressed(prefs, opt) {
        if (opt.cycle) {
            return prefs.textSize !== 'normal';
        }
        return !!prefs[opt.key];
    }

    function optionValueLabel(prefs, opt) {
        if (opt.key === 'textSize') {
            if (prefs.textSize === 'lg') return 'Grande';
            if (prefs.textSize === 'xl') return 'Extra grande';
            return 'Normale';
        }
        return optionPressed(prefs, opt) ? 'Attivo' : 'Off';
    }

    function syncToggleButtons(prefs) {
        modalEl.querySelectorAll('[data-a11y-toggle]').forEach(function (btn) {
            var key = btn.getAttribute('data-a11y-toggle');
            var opt = OPTIONS.filter(function (o) { return o.key === key; })[0];
            if (!opt) return;
            var pressed = optionPressed(prefs, opt);
            btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
            var valEl = btn.querySelector('[data-a11y-value]');
            if (valEl) valEl.textContent = optionValueLabel(prefs, opt);
        });
    }

    function togglePref(key) {
        var prefs = loadPrefs();
        var opt = OPTIONS.filter(function (o) { return o.key === key; })[0];
        if (!opt) return;
        if (opt.cycle) {
            var idx = opt.cycle.indexOf(prefs.textSize);
            if (idx < 0) idx = 0;
            prefs.textSize = opt.cycle[(idx + 1) % opt.cycle.length];
        } else {
            prefs[key] = !prefs[key];
        }
        savePrefs(prefs);
        applyPrefs(prefs);
    }

    function resetPrefs() {
        var prefs = Object.assign({}, DEFAULT_PREFS);
        savePrefs(prefs);
        applyPrefs(prefs);
    }

    function lockScroll(on) {
        try {
            document.documentElement.classList.toggle('vg-kanban-modal-lock', !!on);
        } catch (e) {}
    }

    function getFocusables(root) {
        var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.prototype.slice.call(root.querySelectorAll(sel)).filter(function (el) {
            return el.offsetParent !== null || el === document.activeElement;
        });
    }

    function trapFocus(e) {
        if (!modalEl || e.key !== 'Tab') return;
        var focusables = getFocusables(modalEl);
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    function onEscapeKey(e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (!modalEl) return;
        e.preventDefault();
        e.stopPropagation();
        closeModal();
    }

    function closeModal() {
        if (!modalEl) return;
        document.removeEventListener('keydown', onEscapeKey, true);
        document.removeEventListener('keydown', trapFocus, true);
        modalEl.remove();
        modalEl = null;
        lockScroll(false);
        if (prevFocus && prevFocus.focus) {
            try { prevFocus.focus(); } catch (e) {}
        }
        prevFocus = null;
    }

    function buildModal() {
        var wrap = document.createElement('div');
        wrap.id = 'vg-a11y-modal';
        wrap.className = 'vg-kanban-modal vg-a11y-modal';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.setAttribute('aria-labelledby', 'vg-a11y-title');

        var optionsHtml = OPTIONS.map(function (opt) {
            return (
                '<button type="button" class="vg-a11y-option" data-a11y-toggle="' + opt.key + '" aria-pressed="false">' +
                '  <span><span class="vg-a11y-option__label">' + opt.label + '</span>' +
                '  <span class="vg-a11y-option__hint">' + opt.hint + '</span></span>' +
                '  <span data-a11y-value aria-hidden="true"></span>' +
                '</button>'
            );
        }).join('');

        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel" role="document">' +
            '  <div class="vg-a11y-modal__header">' +
            '    <h2 class="vg-kanban-modal__title" id="vg-a11y-title">Accessibilità</h2>' +
            '    <p class="vg-a11y-modal__intro">Le preferenze si applicano <strong>subito</strong> alla pagina e restano salvate in questo browser.</p>' +
            '  </div>' +
            '  <div class="vg-a11y-modal__body">' +
            '    <dl class="vg-a11y-modal__shortcuts">' +
            '      <dt>Apri questo pannello</dt>' +
            '      <dd><kbd>Alt</kbd>+<kbd>Shift</kbd>+<kbd>A</kbd> (Windows/Linux) · <kbd>⌥ Option</kbd>+<kbd>Shift</kbd>+<kbd>A</kbd> (Mac)</dd>' +
            '      <dt>Chiudi</dt><dd><kbd>Esc</kbd></dd>' +
            '      <dt>Salta al contenuto</dt><dd>Primo <kbd>Tab</kbd> → link «Vai al contenuto»</dd>' +
            '    </dl>' +
            '    <div class="vg-a11y-options" role="group" aria-label="Preferenze di visualizzazione">' + optionsHtml + '</div>' +
            '    <p class="vg-a11y-modal__guide"><a href="/accessibilita/">Guida accessibilità completa</a></p>' +
            '    <div class="vg-visually-hidden" data-a11y-live aria-live="polite" aria-atomic="true"></div>' +
            '  </div>' +
            '  <div class="vg-a11y-modal__actions">' +
            '    <button type="button" class="vg-kanban-modal__btn" data-a11y-reset>Ripristina predefiniti</button>' +
            '    <button type="button" class="vg-kanban-modal__btn vg-kanban-modal__btn--danger" data-a11y-close>Chiudi</button>' +
            '  </div>' +
            '</div>';

        wrap.addEventListener('click', function (e) {
            if (e.target === wrap) closeModal();
        });

        wrap.querySelectorAll('[data-a11y-toggle]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                togglePref(btn.getAttribute('data-a11y-toggle'));
            });
        });

        wrap.querySelector('[data-a11y-reset]').addEventListener('click', resetPrefs);
        wrap.querySelector('[data-a11y-close]').addEventListener('click', closeModal);

        return wrap;
    }

    function openModal(focusTrigger) {
        if (modalEl) {
            closeModal();
            return;
        }
        prevFocus = focusTrigger || document.activeElement;
        modalEl = buildModal();
        document.body.appendChild(modalEl);
        lockScroll(true);
        applyPrefs(loadPrefs());
        document.addEventListener('keydown', onEscapeKey, true);
        document.addEventListener('keydown', trapFocus, true);
        var first = modalEl.querySelector('[data-a11y-toggle]') || modalEl.querySelector('[data-a11y-close]');
        if (first) first.focus();
    }

    function onGlobalShortcut(e) {
        if (!e.altKey || !e.shiftKey) return;
        if (e.code !== 'KeyA') return;
        if (e.ctrlKey || e.metaKey) return;
        var tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        if (e.target && e.target.isContentEditable) return;
        e.preventDefault();
        openModal(triggerEl);
    }

    function init() {
        applyPrefs(loadPrefs());
        triggerEl = document.querySelector('[data-vg-a11y-open]');
        document.querySelectorAll('[data-vg-a11y-open]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                triggerEl = btn;
                openModal(btn);
            });
        });
        document.addEventListener('keydown', onGlobalShortcut, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.VgA11y = {
        open: function () { openModal(triggerEl); },
        close: closeModal,
        getPrefs: loadPrefs,
        applyPrefs: applyPrefs
    };
})();
